import ListRoles from '../pages/roles/listRoles.vue';
import CreateRole from '../pages/roles/createRole.vue';

export default [
    {
        path: "/roles",
        name: "ListRoles",
        component: ListRoles,
        meta: {
            name: 'Roles',
            requireAuth: true
        }
    },
    {
        path: "/roles/create",
        name: "CreateRole",
        component: CreateRole,
        meta: {
            name: 'Create Role',
            requireAuth: true
        }
    },
    {
        path: "/roles/edit/:id",
        name: "EditRole",
        component: CreateRole,
        meta: {
            name: 'Edit Role',
            requireAuth: true
        }
    }
]
